import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isLoggedIn: false,
    token: null,
    userInfo: {},
    role: "",
    profile_image: "",
  },
  reducers: {
    login(state, action) {
      state.isLoggedIn = true;
      state.token = action.payload.token;
      state.role = action.payload.role;
      state.userInfo = action.payload.userInfo;
      state.profile_image = action.payload.profile_image;
    },
    logout(state) {
      state.isLoggedIn = false;
      state.token = null;
      state.role = "";
      state.userInfo = {};
      state.profile_image = "";
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
